import React from 'react';
import MenuLinks from './MenuLinks';
import classnames from 'classnames';
var Menu = function Menu(props) {
  var classes = classnames('hc-c-menu', {
    'hc-c-menu--open': props.open
  });
  return /*#__PURE__*/React.createElement("div", {
    id: "hc-c-menu",
    hidden: !props.open,
    className: classes
  }, props.submenuTop, props.beforeLinks, props.links && /*#__PURE__*/React.createElement(MenuLinks, {
    links: props.links
  }), props.submenuBottom);
};
export default Menu;